import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContactCTA from '../components/ContactCTA';

export default function PageLayout({ children, showContact = true }) {
  return (
    <div className="min-h-screen bg-white" style={{ paddingTop: '64px' }}>
      <Navbar />
      {children}
      {showContact && <ContactCTA />}
      <Footer />
    </div>
  );
}
